import { render } from "./Ships.vue?vue&type=template&id=77c4631a"
import script from "./Ships.vue?vue&type=script&lang=js"
export * from "./Ships.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__